import type { FormatPipeline } from '~/utils/formatters/prtials/formatPipeline';

export type TCommonErrorType = {
  code: number;
  message: string;
};

export type TNullable<T> = T | null;

export type TWeb3ModalProvider = {
  request: (request: { method: string; params?: any[] | Record<string, any> | undefined }) => Promise<any>;
};

export enum WebSocketsKeys {
  streetMerchant = 'street-merchant',
  flipCoinGame = 'flip-coin-game',
  craftingActivity = 'crafting-activity'
}

export type ChartDataFormatterProps = {
  formatters: {
    label: FormatPipeline<string>;
    tooltip: FormatPipeline<string>;
  };
};
